import { connect } from 'react-redux';
import Zoom from './zoom';
import { zoomIn, zoomOut } from '../../../shared/actions/setScale';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  zoomIn: () => dispatch(zoomIn()),
  zoomOut: () => dispatch(zoomOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Zoom);
